import { createTheme } from "@mui/material";

// Paleta Otimize — azul confiavel + verde acao + laranja alerta
export const theme = createTheme({
  palette: {
    primary: { main: "#1565c0", dark: "#0d47a1", light: "#42a5f5" },
    secondary: { main: "#43a047", dark: "#2e7d32" },
    warning: { main: "#f57c00" },
    error: { main: "#d32f2f" },
    background: { default: "#f4f6f8", paper: "#ffffff" },
  },
  typography: {
    fontFamily: '"Inter","Roboto","Segoe UI",Arial,sans-serif',
    h6: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  shape: { borderRadius: 8 },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: { boxShadow: "0 2px 4px rgba(0,0,0,0.08)" },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          border: "1px solid #eaecef",
        },
      },
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: { border: "1px solid #eaecef" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
  },
});

export const SUPPORT = {
  email: "suporte@otimizeinformatica.com.br",
  whatsapp: "555131811999",
  whatsappDisplay: "(51) 3181-1999",
  site: "https://otimizeinformatica.com.br",
};
